exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".footer_background_color {\n  background-color: #363636 !important;\n}\n\n.footer_text_color {\n  color: #C4C4C4;\n}\n\n.block {\n  display: block;\n}\n\n/*Mobile L version*/\n@media screen and (max-width: 800px) {\n  .footer-contacts.d-flex {\n    flex-direction: column;\n    align-items: center;\n  }\n}", ""]);

// exports
